import React from "react";
import { Navigate } from "react-router-dom";

const MyAccountPanel = React.lazy(
  () => import("../../../../../components/my-account/components/panel/page"),
);
const TemplateCreateComponent = React.lazy(
  () =>
    import("../../../../../components/document-template/components/add/page"),
);

export const systemRoutes = [
  {
    path: "panel",
    element: <MyAccountPanel />,
  },
  {
    path: "templates",
    element: <TemplateCreateComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/configuration/system/panel" />,
  },
];
